var map = {
	"./1-1.svg": "1724",
	"./1-10.svg": "bd5c",
	"./1-11.svg": "b3ff",
	"./1-2.svg": "93b7",
	"./1-3.svg": "4452",
	"./1-4.svg": "5f5d",
	"./1-5.svg": "e331",
	"./1-6.svg": "d37e",
	"./1-7.svg": "1e11",
	"./1-8.svg": "2400",
	"./1-9.svg": "eddb",
	"./2-1.svg": "029f",
	"./2-10.svg": "f770",
	"./2-11.svg": "e140",
	"./2-12.svg": "ee2d",
	"./2-2.svg": "8fb0",
	"./2-3.svg": "624b",
	"./2-4.svg": "a3749",
	"./2-5.svg": "9090",
	"./2-6.svg": "991a",
	"./2-7.svg": "c940",
	"./2-8.svg": "ce9c",
	"./2-9.svg": "db0a",
	"./3-1.svg": "1d8d",
	"./3-10.svg": "2cdc",
	"./3-2.svg": "eb18",
	"./3-3.svg": "f483",
	"./3-4.svg": "ec7a",
	"./3-5.svg": "88fe",
	"./3-6.svg": "e96e",
	"./3-7.svg": "474d",
	"./3-8.svg": "d215",
	"./3-9.svg": "a36f",
	"./sticker-0-0--1.svg": "4202",
	"./sticker-0-0.svg": "d50a",
	"./sticker-0-1.svg": "273b",
	"./sticker-0-2.svg": "5e69",
	"./sticker-0-4.svg": "06da",
	"./sticker-0-5.svg": "b803",
	"./sticker-0-6.svg": "b595",
	"./sticker-0-7.svg": "78fe",
	"./sticker-0-8.svg": "9ddd",
	"./sticker-1-0.svg": "3541",
	"./sticker-1-1.svg": "9f44",
	"./sticker-1-2.svg": "dae6",
	"./sticker-2-0.svg": "8ad5",
	"./sticker-2-1.svg": "2aad",
	"./sticker-2-2.svg": "c15c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f70";